import { render } from "./createRecepcion.vue?vue&type=template&id=aed934ac&scoped=true"
import script from "./createRecepcion.vue?vue&type=script&lang=js"
export * from "./createRecepcion.vue?vue&type=script&lang=js"

import "./createRecepcion.vue?vue&type=style&index=0&id=aed934ac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aed934ac"]])

export default __exports__